import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { appRoutes } from './routes';
import Scale from './Scale';

interface IProps {
    isAuthenticated: boolean;
}

export const OpensiteRoutes: React.FC<IProps> = ({ isAuthenticated }) => {
    const location = useLocation();
    return isAuthenticated ? (
        <Navigate to={`/${appRoutes.DASH_BOARD.ROOT}`} state={{ from: location }} replace />
    ) : (
        <>
            <Outlet />
            <Scale />
        </>
    );
};
